import { useSelector, } from 'react-redux';
import { ISipStore, IReducerStore, } from '@Store';

export const useSipUsers = (): ISipStore => {
  return useSelector((store: IReducerStore) => store.sip_users);
};
